// Testo mostrato sia nella pagina "quinto-puoi" che nella landing page "landing-dipendenti-privati"
import React from 'react'
import H2 from '../../commons/H2'
import P from '../../commons/P'
import Ul from './Ul'
import Li from './Li'

const DipendentiPrivatiText = () => {
  return (
    <>
      <H2 style={{marginTop: '3rem'}}>REQUISITI</H2>
      <Ul>
        <Li><span>Per richiedere il finanziamento è necessario avere almeno 18 anni, essere un dipendente con un contratto di lavoro a tempo indeterminato, aver maturato almeno il periodo di prova presso l’azienda in cui si presta servizio ed essere residente in Italia. È indispensabile essere assunti da società SPA/SRL con più di 15 dipendenti o da cooperative con oltre 50 dipendenti. Il finanziamento non viene erogato a lavoratori in p.iva, autonomi e dipendenti con tipologie contrattuali diverse dal tempo indeterminato.&nbsp;</span>
        </Li>
        <Li><span>La concessione del finanziamento è subordinata alla valutazione complessiva della posizione creditizia del Cliente e di conseguenza dell’importo oggetto di richiesta.</span>
        </Li>
      </Ul>
      <P style={{fontSize: '1rem'}}>
        Per informazioni economiche e contrattuali fare riferimento alle
        “Informazioni Europee di Base sul Credito ai Consumatori” (SECCI) che puoi richiedere presso tutte
        le filiali della Banca e presso gli agenti in attività finanziaria che operano su mandato diretto
        della Banca per la promozione e il collocamento del prodotto QuintoPuoi. La concessione del
        finanziamento è subordinata all’approvazione di Banca Sistema S.p.A..
      </P>
      <H2 style={{marginTop: '3rem'}}>DOCUMENTI</H2>
      <Ul className="checked">
        <Li>Un documento di riconoscimento valido&nbsp;</Li>
        <Li>Il codice fiscale</Li>
        <Li>Il certificato di stipendio o l’Attestato di servizio</Li>
        <Li>Ultime due buste paga</Li>
        <Li>La Certificazione Unica</Li>
      </Ul>
    </>
  )
}

export default DipendentiPrivatiText
